angular.module('picmonicng').controller('GetStartedController', [
  '$scope',
  '$stateParams',
  '$cookies',
  'Pathways',
  'BrowseService',
  'SearchService',
  'UserService',
  'MarketOptionsConfig',
  'MetaService',
  'MarketSelectorModalService',
  function (
    $scope,
    $stateParams,
    $cookies,
    Pathways,
    BrowseService,
    SearchService,
    UserService,
    MarketOptionsConfig,
    MetaService,
    MarketSelectorModalService
  ) {
    $stateParams.browseParams = $stateParams.browseParams ? JSON.parse($stateParams.browseParams) : {};

    if (UserService.user.lead) {
      $scope.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
    } else if ($stateParams.market) {
      $scope.market = MarketOptionsConfig.getMarketBySlug($stateParams.market);
    } else if ($stateParams.browseParams.market) {
      $scope.market = MarketOptionsConfig.getMarketBySlug($stateParams.browseParams.market);
    } else if ($cookies.get('pls_user_lead')) {
      $scope.market = MarketOptionsConfig.getMarketById($cookies.get('pls_user_lead'));
    } else {
      MarketSelectorModalService.showMarketSelectorModal();
    }
    $scope.$emit('endInteraction');

    if ($scope.market) {
      UserService.setMarketCookies($scope.market.id);
    }

    $scope.SearchService = SearchService;

    $scope.search = function () {
      BrowseService.go('app.search', { q: $scope.SearchService.searchTerm });
      if (window.innerWidth > 768) {
        angular.element(document).find('.search-input').focus();
      } else {
        document.activeElement.blur();
      }
    };

    // Generic for opening browse in any state
    if ($stateParams.browse) {
      BrowseService.go($stateParams.browse, $stateParams.browseParams);
    }

    // SEO Shortcut to open pathways and paths
    if (
      $stateParams.pathway_type &&
      $stateParams.curriculum &&
      (!UserService.user.user_id || (UserService.user.user_id && UserService.user.lead == $scope.market.id))
    ) {
      BrowseService.go('home', {
        market: $scope.market.slug,
        pathway_type: $stateParams.pathway_type,
        curriculum: $stateParams.curriculum,
      });
    } else if (
      $stateParams.path &&
      (!UserService.user.user_id || (UserService.user.user_id && UserService.user.lead == $scope.market.id))
    ) {
      BrowseService.go('app.pathways.market.courses.tracks.picmonics', {
        market: $scope.market.slug,
        pathway_id: $stateParams.pathway,
        track_id: $stateParams.path,
      });
    } else if (
      $stateParams.pathway &&
      (!UserService.user.user_id || (UserService.user.user_id && UserService.user.lead == $scope.market.id))
    ) {
      BrowseService.go('app.pathways.market.courses.tracks', {
        market: $scope.market.slug,
        pathway_id: $stateParams.pathway,
      });
    }
  },
]);
